import { render, staticRenderFns } from "./StudentRegister.vue?vue&type=template&id=aa8b1390&scoped=true&"
import script from "./StudentRegister.vue?vue&type=script&lang=js&"
export * from "./StudentRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8b1390",
  null
  
)

export default component.exports